import { C55BiographyDirectoryProps } from './C55BiographyDirectory.types';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { BioCardDirectory } from '@ahc-digital/component-library';
import { GetBiographyDirectoryModel } from './C55BiographyDirectory.service';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C55BiographyDirectoryProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <BioCardDirectory
      data-component={marketingRenderingName}
      {...GetBiographyDirectoryModel(props)}
    />
  );
};
